$(document).on('click', '.wwd-text-container', showWhatWeDo);
//event when scroll
$(window).scroll(function(){
    if($(this).scrollTop() > 0){
        $('#slide-info-container').removeClass('slide-info-container-transparent').addClass('slide-info-container-white');
        $('#slide-icon').attr('src',$('#slide-icon').attr('color-src'));
    }else{
        $('#slide-info-container').removeClass('slide-info-container-white').addClass('slide-info-container-transparent');
        $('#slide-icon').attr('src',$('#slide-icon').attr('transparent-src'));
    }
});
$(document).ready(function(){
    getCallToActionMessage();
});
function showWhatWeDo(){
    let container = $(this);
    container.find('.wwd-item-title').toggleClass('d-none');
    container.find('.fa-angle-right').toggleClass('d-none');
    container.find('.wwd-item-paragraph').toggleClass('d-none');
}
function getCallToActionMessage(){
    var DataSend = {};
    PostMethodFunction('/Home/Service/CallToAction', DataSend, null, setCallToActionMessage, null);
}
function setCallToActionMessage(response){
    console.log('setCallToActionMessage => ', response.data);
    $('#cta-title').text(response.data[0]);
}